<template>
  <div>
    <v-toolbar flat height="80px" dark color="secondary">
      <v-toolbar-title v-if="type !== 'EditLead'">New {{contact.type}}</v-toolbar-title>
      <v-toolbar-title v-if="type === 'EditLead'">Edit Lead</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="type === 'EditLead' && user.permissions.others.deleteLeads" @click="deleteLead" outline class="error error--text"><v-icon>clear</v-icon>Delete Lead</v-btn>
      <v-btn class="ml-4" dark flat icon @click="closeContactDialog"><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-container style="background-color:white">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-md>
          <!-- Existing Customer / Builder Selection -->
          <v-layout v-if="(newLeadType === 'Existing' || newLeadType === 'Builder') && type !== 'EditLead'">
            <v-toolbar dark color="primary">
              <v-toolbar-title><v-icon class="mr-2">person</v-icon>{{ ifBuilder ? 'Builder:' : 'Customer:' }}</v-toolbar-title>
              <v-autocomplete autofocus :loading="loading" :items="items" :search-input.sync="search" v-model="customerSelect" cache-items
                class="mx-3" flat hide-no-data hide-details :label="ifBuilder ? 'Search Builders' : 'Search Customers'" solo-inverted @change="getContactDetails">
              </v-autocomplete>
            </v-toolbar>
          </v-layout>
          <p v-if="!getContact && validating === true" class="mt-3 title red--text">You Must Enter a Customer</p>
          <!-- END: Existing Customer / Builder Selection -->
          <v-layout mt-3 justify-center>
            <span class="headline font-weight-thin">{{contact.type}} Information</span>
          </v-layout>
          <v-layout row wrap>
            <!-- If Adding New Builder Lead -->
            <v-flex xs12 sm6 v-if="(newLeadType === 'Builder' || opportunity.job_name) && !isBuilderToContact">
              <v-text-field v-model="opportunity.job_name" :rules="nameRules" :counter="50" label="Job Name" required prepend-icon="home"></v-text-field>
            </v-flex>
            <!-- If Creating New Builder Contact Record -->
            <v-flex xs12 v-if="contact.type === 'Builder'">
              <v-text-field v-model="builder.company_name" :rules="nameRules" :counter="30" label="Company Name (Builder Name)" required prepend-icon="home"></v-text-field>
            </v-flex>
            <!-- Builder Address Information -->
            <v-layout row wrap v-if="contact.type === 'Builder'">
              <v-flex xs12>
                <v-text-field v-model="builder.address" clearable name="address" label="Address" prepend-icon="add_location"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builder.city" clearable name="city" label="City" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="builder.state" clearable name="state" label="State (i.e. FL)" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="builder.zip" clearable name="zip" label="Zip"></v-text-field>
              </v-flex>
            </v-layout>
            <!-- Create Customer Data -->
            <template v-if="newLeadType === 'New' || completedProject || isBuilderToContact || (type === 'EditLead' && selectedLead.type !== 'Builder') || newCustomer">
            <v-flex sm6 xs12>
              <v-text-field v-model="contactDetails.first_name" :rules="validationRequired" label="First Name" required prepend-icon="person"></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field v-model="contactDetails.last_name" :rules="validationRequired" label="Last Name" required prepend-icon="person"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="contactDetails.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
            </v-flex>
            <v-flex sm6 xs7>
              <v-text-field v-model="contactDetails.phone_1" :rules="validationRequired" name="phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
            </v-flex>
            <v-flex sm5 xs4>
              <v-select v-model="contactDetails.phone_type_1" :items="phoneOptions" label="Type"></v-select>
            </v-flex>
            <v-flex sm1 xs1>
              <v-btn fab small color="primary" @click="phone2 = !phone2"><v-icon>{{ phone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
            </v-flex>
            <v-flex sm6 xs7 v-if="phone2">
              <v-text-field v-model="contactDetails.phone_2" name="phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
            </v-flex>
            <v-flex sm5 xs4 v-if="phone2">
              <v-select v-model="contactDetails.phone_type_2" :items="phoneOptions" label="Type"></v-select>
            </v-flex>
            </template>
            <!-- <template v-if="newLeadType === 'New' || completedProject || isBuilderToContact || (type === 'EditLead' && selectedLead.type !== 'Builder')">
              <v-flex sm6 xs7>
                <v-text-field v-model="builder.phone_1" name="phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
              </v-flex>
            </template> -->
            <!-- Secondary Contact Information -->
                <v-layout row wrap v-if="newLeadType === 'New' || completedProject || isBuilderToContact || (type === 'EditLead' && selectedLead.type !== 'Builder')">
                  <v-flex xs12 class="text-xs-right">
                    <v-chip color="indigo" text-color="white" @click="showSecondaryContact = !showSecondaryContact; lastName()"><v-icon class="pr-3 hover">person_add</v-icon>{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-chip>
                    <!-- <v-btn small color="primary" @click="showSecondaryContact = !showSecondaryContact">{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-btn> -->
                  </v-flex>
                  <template v-if="showSecondaryContact">
                  <v-flex sm6 xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_first_name" :rules="validationRequired" label="First Name" required prepend-icon="person"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_last_name" :rules="validationRequired" label="Last Name" required prepend-icon="person"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs7>
                    <v-text-field v-model="secondaryContact.secondaryContact_phone_1" name="secondaryContact_phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                  </v-flex>
                  <v-flex sm5 xs4>
                    <v-select v-model="secondaryContact.secondaryContact_phone_type_1" :items="phoneOptions" label="Type"></v-select>
                  </v-flex>
                  <v-flex sm1 xs1>
                    <v-btn fab small color="primary" @click="secondaryPhone2 = !secondaryPhone2"><v-icon>{{ secondaryPhone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
                  </v-flex>
                  <v-flex sm6 xs7 v-if="secondaryPhone2">
                    <v-text-field v-model="secondaryContact.secondaryContact_phone_2" name="secondaryContact_phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                  </v-flex>
                  <v-flex sm5 xs4 v-if="secondaryPhone2">
                    <v-select v-model="secondaryContact.secondaryContact_phone_type_2" :items="phoneOptions" label="Type"></v-select>
                  </v-flex>
                  </template>
                </v-layout>
            <v-divider style="background-color: rgb(63, 81, 181); margin-top:20px; margin-bottom:20px; border: solid 1px rgb(63, 81, 181)" light v-if="showSecondaryContact"></v-divider>
            <v-layout row wrap>
            <!-- Address Information -->
            <template v-if="newLeadType === 'New' || completedProject || isBuilderToContact || (type === 'EditLead' && selectedLead.type !== 'Builder')">
              <v-flex xs12>
                <v-text-field v-model="contactAddress.address" :rules="contact.type == 'Builder' ? [] : validationRequired" name="address" label="Contact Address" prepend-icon="add_location"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="contactAddress.city" :rules="contact.type == 'Builder' ? [] : validationRequired" name="city" label="Contact City" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="contactAddress.state" :rules="contact.type == 'Builder' ? [] : validationRequired" name="state" label="Contact State" prepend-icon=" "></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="contactAddress.zip" :rules="contact.type == 'Builder' ? [] : validationRequired" name="zip" label="Contact Zip"></v-text-field>
              </v-flex>
            </template>
            <!-- Referral Information -->
            <template v-if="!completedProject && contact.type !== 'Builder'">
              <v-flex sm6 xs12>
                <v-layout row>
                  <v-select v-model="opportunity.source" :rules="validationRequired" :items="sourceOptions" item-text="name" label="How did they hear about us?" prepend-icon="record_voice_over" required></v-select>
                  <v-btn v-if="user.permissions.dropdowns.referralSources" flat icon @click="dropDownType = 'referralSources'; editDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="opportunity.source">
                <v-text-field v-model="opportunity.referred_by" label="Provide Any Additional Referral Information" prepend-icon="record_voice_over"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 v-if="contact.type !== 'Builder'">
                <v-select v-model="salesRep" :rules="validationRequired" :items="userNames" label="Sales Rep:" prepend-icon="person_add" required></v-select>
              </v-flex>
            </template>
            </v-layout>
          </v-layout>
          <!-- Lead Opportunity Data -->
          <template v-if="(newLeadType || type === 'EditLead')">
            <v-layout mt-4 justify-center>
              <span class="headline font-weight-thin">Opportunity Details</span>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.property_survey" label="Property Survey?"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.other_designs" label="Other Designs?"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.financing" label="Financing?"></v-text-field>
              </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="opportunity.budget_min" label="Min Budget" value="0.00" prefix="$"></v-text-field>
                </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="opportunity.budget_max" label="Max Budget" value="0.00" prefix="$"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="type !== 'EditLead'">
              <v-flex xs12 v-if="newLeadType === 'New' || type === 'EditLead'">
                <v-checkbox v-model="addressSameAsContact" label="Property Address Same As Customer" color="success" hide-details></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!addressSameAsContact || type === 'EditLead'">
              <v-flex xs12>
                <v-text-field v-model="opportunity.address" :rules="validationRequired" name="address" label="Property Address"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.city" :rules="validationRequired" name="city" label="Property City"></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="opportunity.state" :rules="validationRequired" name="state" label="Property State (i.e. FL)"></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="opportunity.zip" :rules="validationRequired" name="zip" label="Property Zip"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs9>
                <v-text-field v-model="opportunity.building_dept" name="building_dept" label="Building Department"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="opportunity.gate_code" name="gate_code" label="Gate Code"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select clearable v-model="opportunity.builder" @input="getBuilderContacts(opportunity.builder)" :items="builderDropDownList" label="Assign a Builder" required></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select clearable v-model="opportunity.builder_contact" v-if="opportunity.builder" :items="builderContactsDropDownList" :label="'Project Contact from ' + opportunity.builder" required></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="opportunity.hoa" label="HOA / Neighborhood"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="opportunity.description" multi-line rows="1" auto-grow label="Description of Work"></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="opportunity.projectNotes" multi-line rows="1" auto-grow label="General Project Notes"></v-textarea>
              </v-flex>
            </v-layout>
          </template>
          <!-- Builder Contacts -->
          <template v-if="contact.type === 'Builder' && !newLeadType && type !== 'EditLead'">
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <p class="orange white--text">Add Builder Contacts. You can add as many as needed.</p>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.first_name" :counter="30" label="First Name" required prepend-icon="person"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.last_name" :counter="30" label="Last Name" required prepend-icon="person"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.phone" name="phone" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-layout row>
                  <v-select v-model="builderContacts.title" :items="builderTitles" label="Title" clearable chip prepend-icon="account_circle"></v-select>
                  <v-btn v-if="user.permissions.others.manageBuilders" flat icon @click="dropDownType = 'builderTitles'; editDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-chip color="indigo" text-color="white" @click="createBuilderContacts()"><v-icon class="pr-3 hover">person_add</v-icon>Add Another Builder Contact</v-chip>
              </v-flex>
            </v-layout>
            <p></p>
          </template>
          <!-- Added Builder Contacts List -->
          <v-layout row wrap>
          <v-chip v-if="builderContactsArray.length > 0" label color="pink" text-color="white">
            <v-icon left>label</v-icon>Builder Contacts Added:
          </v-chip>
          <template v-for="(contact, index) in builderContactsArray">
            <v-chip @input="removeBuilderContact(index)" v-model="contact.index" close :key="index" color="indigo" text-color="white">
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
              {{ contact.first_name }} {{ contact.last_name }}
            </v-chip>
          </template>
          </v-layout>
        </v-container>
      </v-form>
    <v-layout row wrap>
      <v-flex>
          <v-btn v-if="type !== 'EditLead'" :disabled="!valid" flat class="primary" @click="createContactButton"><v-icon left>person</v-icon>{{ completedProject ? 'Save Contact and Create Project' : 'Save and Close' }}</v-btn>
          <v-btn v-if="type === 'EditLead'" :disabled="!valid" flat class="primary" @click="editLead"><v-icon left>person</v-icon>Save Lead and Close</v-btn>
          <!-- <v-btn v-if="contact.type === 'Customer'" :disabled="!valid" flat class="primary" @click="createProject"><v-icon left>ballot</v-icon>Add Project Information</v-btn> -->
          <v-btn flat class="secondary" @click="closeContactDialog">Cancel</v-btn>
      </v-flex>
    </v-layout>
    <!-- Create Project Dialog -->
    <v-dialog max-width="800px" persistent v-model="createProjectDialog">
      <create-project v-if="createProjectDialog" :contact="contactProp" @closeContactDialog="closeContactDialog" @closeDialog="closeProjectAndContactDialog"/>
    </v-dialog>
    <!-- End: Create Project Dialog -->
    <!-- Edit Drop Down -->
    <v-dialog max-width="600px" v-model="editDropdownDialog">
      <edit-dropdown v-if="editDropdownDialog" :dropdownName="dropDownType" @closeDialog="editDropdownDialog = false"/>
    </v-dialog>
    <!-- End: Edit Drop Down -->
    <v-alert :value="error !== null ? true : false" color="error" icon="new_releases">An error has occured. Try again. Error details: {{ error }}</v-alert>
  </v-container>
  </div>
</template>

<script>
import { db } from '../../firebaseInit'
import CreateProject from '../projects/CreateProject'
import EditDropdown from '../../helpers/EditDropdown'
import _ from 'lodash'

export default {
  props: ['newLeadType', 'newCustomer', 'newBuilder', 'ifBuilder', 'type', 'selectedLead', 'completedProject', 'isBuilderToContact', 'builderToCustomerProjectData', 'builderToCustomerContactData'],
  data () {
    return {
      dropDownType: null,
      editDropdownDialog: false,
      createProjectDialog: false,
      phone2: false,
      secondaryPhone2: false,
      valid: true,
      validating: false,
      salesRep: null,
      addressSameAsContact: true,
      phoneOptions: ['Cell', 'Home', 'Office', 'Other'],
      contactTypeOptions: ['Lead', 'Customer', 'Builder'],
      contact: {id: null, type: 'Customer', created_date: new Date()},
      contactDetails: {first_name: null, last_name: null, email: null, phone_1: null, phone_type_1: null, phone_2: null, phone_type_2: null},
      secondaryContact: {secondaryContact_first_name: null, secondaryContact_last_name: null, secondaryContact_email: null, secondaryContact_phone_1: null, secondaryContact_phone_type_1: null, secondaryContact_phone_2: null, secondaryContact_phone_type_2: null},
      contactAddress: {address: null, city: null, state: null, zip: null},
      opportunity: {job_name: null, created_date: new Date(), active: null, deleted: null, notes: [], project: null, referred_by: null, revertedToLeads: null, sales_rep: null, source: null, status: null, building_dept: null, property_survey: null, other_designs: null, financing: null, budget_min: 0, budget_max: 0, address: null, city: null, state: null, zip: null, gate_code: null, hoa: null, description: null, projectNotes: null, builder: null, builder_contact: null},
      builder: {company_name: null, phone_1: null, address: null, city: null, state: null, zip: null},
      builderContacts: {first_name: null, last_name: null, email: null, phone: null, active: true},
      builderContactList: {},
      builderContactsArray: [],
      builderDropDownList: [],
      builderContactsDropDownList: [],
      contactProp: {},
      showSecondaryContact: null,
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      email: '',
      showValidatedButton: false,
      emailRules: [
        // v => !!v || 'E-mail is required',
        v => v ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid' : true
      ],
      loading: false,
      items: [],
      search: null,
      customerSelect: null,
      getContact: null
    }
  },
  mounted () {
    if (this.isBuilderToContact) {
      this.contactAddress = {address: this.builderToCustomerProjectData.address, city: this.builderToCustomerProjectData.city, state: this.builderToCustomerProjectData.state, zip: this.builderToCustomerProjectData.zip}
      const oppData = this.builderToCustomerContactData.opportunities.filter(f => f.project === this.builderToCustomerProjectData.id)
      this.opportunity = oppData[0]
    }
    if ((this.newLeadType === 'Builder' || this.newLeadType === 'Existing') && this.type !== 'EditLead') {
      this.addressSameAsContact = false
    }
    if (this.type) {
      this.contact.type = this.type
    }
    // Pre-Fill Forms For Lead Edits
    if (this.selectedLead) {
      const editData = this.selectedLead
      const editOpportunity = this.selectedLead.opportunities
      this.contact = {id: editData.id}
      this.secondaryContact = {secondaryContact_first_name: editData.secondaryContact_first_name ? editData.secondaryContact_first_name : null, secondaryContact_last_name: editData.secondaryContact_last_name ? editData.secondaryContact_last_name : null, secondaryContact_email: editData.secondaryContact_email ? editData.secondaryContact_email : null, secondaryContact_phone_1: editData.secondaryContact_phone_1 ? editData.secondaryContact_phone_1 : null, secondaryContact_phone_type_1: editData.secondaryContact_phone_type_1 ? editData.secondaryContact_phone_type_1 : null, secondaryContact_phone_2: editData.secondaryContact_phone_2 ? editData.secondaryContact_phone_2 : null, secondaryContact_phone_type_2: editData.secondaryContact_phone_type_2 ? editData.secondaryContact_phone_type_2 : null}
      this.contactDetails = {first_name: editData.first_name, last_name: editData.last_name, email: editData.email, phone_1: editData.phone_1, phone_type_1: editData.phone_type_1, phone_2: editData.phone_2, phone_type_2: editData.phone_type_2}
      this.contactAddress = {address: editData.address, city: editData.city, state: editData.state, zip: editData.zip}
      this.opportunity = {job_name: editOpportunity.job_name ? editOpportunity.job_name : null, active: editOpportunity.active, deleted: editOpportunity.deleted, notes: editOpportunity.notes, project: editOpportunity.project, referred_by: editOpportunity.referred_by, revertedToLeads: editOpportunity.revertedToLeads, sales_rep: editOpportunity.sales_rep, source: editOpportunity.source, status: editOpportunity.status, created_date: editOpportunity.created_date, building_dept: editOpportunity.building_dept, property_survey: editOpportunity.property_survey, other_designs: editOpportunity.other_designs, financing: editOpportunity.financing, budget_min: editOpportunity.budget_min, budget_max: editOpportunity.budget_max, address: editOpportunity.address, city: editOpportunity.city, state: editOpportunity.state, zip: editOpportunity.zip, gate_code: editOpportunity.gate_code, hoa: editOpportunity.hoa, description: editOpportunity.description, projectNotes: editOpportunity.projectNotes, builder: editOpportunity.builder, builder_contact: editOpportunity.builder_contact}
      this.salesRep = editData.sales_rep.first_name + ' ' + editData.sales_rep.last_name
      if (editOpportunity.builder) {
        this.getBuilderContacts(editOpportunity.builder)
      }
      if (editData.secondaryContact_first_name) {
        this.showSecondaryContact = true
      }
    }
    this.BuildersList()
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
    salesRep () {
      const repData = this.userList.filter(f => f.first_name + ' ' + f.last_name === this.salesRep)
      this.opportunity.sales_rep = repData[0].id
      if (this.type === 'EditLead' && this.contact.sales_rep) {
        this.selectedLead.allOpps[this.selectedLead.opportunities.index].sales_rep = this.contact.sales_rep
      }
    }
  },
  computed: {
    builderTitles () {
      return this.$store.getters.builderTitles
    },
    sourceOptions () {
      return this.$store.getters.referralSources
    },
    contactList () {
      if (this.ifBuilder) {
        return this.$store.getters.builderList.map(a => a.company_name)
      } else {
        return this.$store.getters.getContactSearchList.map(a => a.name)
      }
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    },
    userNames () {
      return this.userList.filter(f => f.if_sales_rep === true).map(m => m.first_name + ' ' + m.last_name)
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    buildersList () {
      let builders = []
      this.$store.getters.builderList.forEach(b => {
        builders.push(b.builder_company_name)
      })
      builders = [...builders, '[Create New Builder]']
      return builders
    },
    createNewBuilder () {
      if (this.contact.company_name === '[Create New Builder]') {
        this.contact.type = 'Builder'
        this.contact.company_name = null
      }
    },
    getAllBuilderNames () {
      return this.$store.getters.builderList
    }
  },
  methods: {
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.contactList.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    },
    getContactDetails () {
      if (this.ifBuilder) {
        let builderDetails = this.$store.getters.builderList.filter(f => { return f.company_name === this.customerSelect })
        builderDetails = Object.assign({}, ...builderDetails)
        this.opportunity.builder = this.customerSelect
        this.getBuilderContacts(this.opportunity.builder)
        db.collection('contacts').doc(builderDetails.id).get().then(query => {
          this.getContact = {...query.data(), id: query.id}
        })
      } else {
        let contactDetails = this.$store.getters.getContactSearchList.filter(f => { return f.name === this.customerSelect })
        contactDetails = Object.assign({}, ...contactDetails)
        db.collection('contacts').doc(contactDetails.id).get().then(query => {
          this.getContact = {...query.data(), id: query.id}
        })
      }
    },
    editLead () {
      this.contact = {...this.contact, active: true, closed_date: this.selectedLead.closed_date, created_date: this.selectedLead.created_date, created_by: this.selectedLead.created_by, deleted: false, projects: this.selectedLead.projects, status: this.selectedLead.status}
      this.contact = {...this.contact, ...this.contactDetails}
      // Include Address Information?
      if (this.contactAddress.address || this.contactAddress.city || this.contactAddress.state || this.contactAddress.zip) {
        this.contact = {...this.contact, ...this.contactAddress}
      }
      // Add Secondary Contacts?
      if (this.selectedLead.secondaryContact_first_name !== this.secondaryContact.secondaryContact_first_name) { this.secondaryContact = {...this.secondaryContact, secondaryContact_first_name: this.secondaryContact.secondaryContact_first_name} }
      if (this.selectedLead.secondaryContact_last_name !== this.secondaryContact.secondaryContact_last_name) { this.secondaryContact = {...this.secondaryContact, secondaryContact_last_name: this.secondaryContact.secondaryContact_last_name} }
      if (this.selectedLead.secondaryContact_email !== this.secondaryContact.secondaryContact_email) { this.secondaryContact = {...this.secondaryContact, secondaryContact_email: this.secondaryContact.secondaryContact_email} }
      if (this.selectedLead.secondaryContact_phone_1 !== this.secondaryContact.secondaryContact_phone_1) { this.secondaryContact = {...this.secondaryContact, secondaryContact_phone_1: this.secondaryContact.secondaryContact_phone_1} }
      if (this.selectedLead.secondaryContact_phone_type_1 !== this.secondaryContact.secondaryContact_phone_type_1) { this.secondaryContact = {...this.secondaryContact, secondaryContact_phone_type_1: this.secondaryContact.secondaryContact_phone_type_1} }
      if (this.selectedLead.secondaryContact_phone_2 !== this.secondaryContact.secondaryContact_phone_2) { this.secondaryContact = {...this.secondaryContact, secondaryContact_phone_2: this.secondaryContact.secondaryContact_phone_2} }
      if (this.selectedLead.secondaryContact_phone_type_2 !== this.secondaryContact.secondaryContact_phone_type_2) { this.secondaryContact = {...this.secondaryContact, secondaryContact_phone_type_2: this.secondaryContact.secondaryContact_phone_type_2} }
      this.contact = {...this.contact, ...this.secondaryContact}
      // Add Opportunity Data
      // this.contact.opportunities = this.opportunity
      // Find Changes
      let difference = Object.keys(this.selectedLead).filter(k => this.selectedLead[k] !== this.contact[k])
      const opportunityDifference = Object.keys(this.selectedLead.opportunities).filter(k => this.selectedLead.opportunities[k] !== this.opportunity[k])
      // Remove not needed sub properties:
      difference = difference.filter(f => f !== 'assigned_to' && f !== 'opportunities' && f !== 'sales_rep' && f !== 'statusOrder' && f !== 'notes' && f !== 'allOpps' && f !== 'deleted' && f !== 'ifOppsPhase' && f !== 'referred_by' && f !== 'source' && f !== 'type' && f !== 'contract_amount' && f !== 'revertedToLeads' && f !== 'company_name' && f !== 'builder_contacts')
      let newState = {}
      difference.forEach(item => {
        newState = {...newState, [item]: this.contact[item]}
      })
      let previousState = {}
      difference.forEach(item => {
        previousState = {...previousState, [item]: this.selectedLead[item]}
      })
      // Add sales_rep if changed
      if (this.selectedLead.sales_rep.id !== this.opportunity.sales_rep) {
        newState = {...newState, sales_rep: this.opportunity.sales_rep}
        previousState = {...previousState, sales_rep: this.selectedLead.sales_rep.id}
      }
      const contactData = Object.assign({}, newState)
      // Add Opportunity Data
      if (opportunityDifference) {
        opportunityDifference.forEach(item => {
          if (item !== 'index' && item !== 'name' && item !== 'closed_date' && item !== 'contact_amount') {
            const propertyName = 'opportunities.' + item
            newState = {...newState, [propertyName]: this.opportunity[item]}
          }
        })
        opportunityDifference.forEach(item => {
          if (item !== 'index' && item !== 'name' && item !== 'closed_date' && item !== 'contact_amount') {
            const propertyName = 'opportunities.' + item
            previousState = {...previousState, [propertyName]: this.selectedLead.opportunities[item]}
          }
        })
      }
      if (contactData.sales_rep) {
        this.opportunity.sales_rep = contactData.sales_rep
        delete contactData.sales_rep
      }
      // Add id to newState
      this.selectedLead.allOpps[this.selectedLead.opportunities.index] = this.opportunity
      // If Sales Rep Change
      let payload = {log: {changedFrom: previousState, changedTo: newState}, update: {...contactData, opportunities: this.selectedLead.allOpps}, contactId: this.selectedLead.id, contactName: this.contact.first_name + ' ' + this.contact.last_name, logMessage: 'changed', refresh: true}
      // Fix UNDEFINED values to NULL
      payload.update.opportunities.forEach((opp, idx) => {
        const getKeys = Object.keys(opp)
        getKeys.forEach(key => {
          if (opp[key] === undefined) {
            payload.update.opportunities[idx][key] = null
          }
        })
      })
      this.$store.dispatch('updateLead', payload)
      this.$emit('editLead')
    },
    deleteLead () {
      if (confirm('Are you sure you want to delete this lead?')) {
        this.$emit('deleteLead')
      }
    },
    BuildersList () {
      let obj = this.$store.getters.builderList
      obj.forEach(item => {
        this.builderDropDownList.push(item.company_name)
      })
      this.builderDropDownList = this.builderDropDownList.sort()
    },
    getBuilderContacts (companyName) {
      const builders = this.$store.getters.builderList
      const builder = builders.filter(filter => filter.company_name === companyName)
      if (builder[0] && builder[0].builder_contacts) {
        builder[0].builder_contacts.forEach(item => {
          this.builderContactsDropDownList.push(item.first_name + ' ' + item.last_name)
        })
      }
    },
    handler () {
      this.clearProperties()
    },
    closeContactDialog () {
      this.$emit('closeCreateDialog')
    },
    closeProjectAndContactDialog () {
      this.createProjectDialog = false
      this.closeContactDialog()
    },
    createContactButton () {
      this.validating = true
      if (this.$refs.form.validate()) {
        this.createBuilderContacts()
        // Adding a Fresh New Lead
        if (this.newLeadType === 'New' || this.completedProject || this.newBuilder || this.isBuilderToContact) {
          this.createContact()
          this.closeContactDialog()
        }
        // Adding a new Opportunity to an Existing Customer / Lead
        if ((this.newLeadType === 'Existing' || this.newLeadType === 'Builder') && this.getContact) {
          this.validating = false
          this.opportunity = {...this.opportunity, active: true, deleted: false, status: 'New Lead'}
          const payload = {contact: this.getContact, opportunity: this.opportunity}
          this.$store.dispatch('addNewOpportunity', payload)
          this.$emit('newLead', {...payload.contact, opportunities: [payload.opportunity]})
          this.closeContactDialog()
        }
      }
    },
    createContact () {
      // Set Contact Id (Timestamp)
      this.setId()
      // What Type of Customer?
      if (this.contact.type === 'Customer' || this.contact.type === 'Lead') {
        this.contact = {...this.contact, ...this.contactDetails}
      }
      // Include Address Information?
      // if (this.contactAddress.address || this.contactAddress.city || this.contactAddress.state || this.contactAddress.zip) {
      // Removed IF because the addresses where not being created and causing UNDEFINED when writing to the log
      this.contact = {...this.contact, ...this.contactAddress}
      // }
      // Add Secondary Contacts?
      if (this.showSecondaryContact) {
        this.contact = {...this.contact, ...this.secondaryContact}
      }
      // Lead Opportunity Data
      if (this.contact.type === 'Lead') {
        this.contactAddressPass()
        this.opportunity = {...this.opportunity, active: true, deleted: false, status: 'New Lead'}
        console.log('The Opp', this.opportunity)
        this.contact = {...this.contact, opportunities: [this.opportunity], status: 'New Lead', ifOppsPhase: true}
      }
      // Is it a Builder?
      if (this.contact.type === 'Builder') {
        this.contact = {...this.contact, builder_contacts: []}
        this.contact = {...this.contact, ...this.builder, type: 'Builder'}
        this.contact.builder_contacts = this.builderContactsArray
      }
      this.contactProp = this.contact
      if (this.newLeadType === 'New') {
        this.$emit('newLead', this.contact)
      }
      // Is this a Builder to Customer Transistion?
      if (this.isBuilderToContact) {
        if (this.opportunity.notes) {
          delete this.opportunity.notes
        }
        this.contact = { ...this.contact, opportunities: [this.opportunity], projects: { [this.builderToCustomerProjectData.id]: true }, isFromBuilder: true }
        // Update Project "Contacts" Property
        let contactPayload = { project: this.builderToCustomerProjectData, newState: { contacts: { [this.builderToCustomerContactData.id]: false, [this.contact.id]: true } }, previousState: { contacts: { [this.builderToCustomerContactData.id]: true } } }
        this.$store.dispatch('projectUpdate', contactPayload)
      }
      // delete this.contact.opportunities[0].notes
      console.log('CreateContact', this.contact)
      this.$store.dispatch('createContact', this.contact)
      this.$emit('builderToCustomerChange', this.contact)
      // If This is a Completed Project Contact - Send to Completed Project Screen
      if (this.completedProject) {
        this.$emit('sendToProject', this.contact.id)
      }
    },
    createBuilderContacts () {
      if (this.builderContacts.first_name) {
        this.builderContactsArray.push(this.builderContacts)
      }
      this.builderContacts = {first_name: null, last_name: null, email: null, phone: null, active: true}
    },
    removeBuilderContact (index) {
      this.builderContactsArray.splice(index, [index])
    },
    contactAddressPass () {
      if (this.addressSameAsContact) {
        this.opportunity.address = this.contact.address
        this.opportunity.city = this.contact.city
        this.opportunity.state = this.contact.state
        this.opportunity.zip = this.contact.zip
      }
    },
    createProject () {
      if (this.$refs.form.validate()) {
        this.createContact()
        this.createProjectDialog = true
      }
    },
    setId () {
      let milliseconds = String((new Date()).getTime())
      let timestamp = milliseconds + '-' + Math.floor(Math.random() * 100) + 10
      this.contact.id = timestamp // Set the contact.id - forcing timestamp refresh
    },
    lastName () {
      this.secondaryContact.secondaryContact_last_name = this.contact.last_name
    }
  },
  components: {
    CreateProject,
    EditDropdown
  }
}
</script>

<style scoped>
.btn--floating.btn--small .icon {
  font-size: 30px;
}
.btn--floating.btn--small {
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/contacts/CreateContact.vue